module.exports = __webpack_public_path__ + "static/media/screen-behavioral-03.6e719dc6.jpg";